import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// config
import * as CONFIG from "./config";

// styles
import { convertPxToRem } from "frontend/components/helpers";

const MockApolloQueryStyled = styled.div`
    .Inner {
        text-align: center;
        max-width: 1000px;
        margin: ${convertPxToRem(50)} auto;
        padding: 20px;
    }

    h1 {
        margin: 20px 0px;
        font-size: 30px;
        line-height: 150%;
    }

    .message {
        font-size: 20px;
        border: dotted 3px red;
        margin: 30px 0px;
        padding: 50px 0px;
    }

    .children {
        margin: 30px 0px;
        padding: 50px 0px;
        border: dotted 3px #999;
    }

    &:nth-child(even) {
        background-color: #eee;
    }
`;

// components
import Button from "core/Button";

const MockApolloQuery = ({ title, apolloCall, children }) => {
    const [message, setMessage] = useState("Api Call: Pending");
    const onClick = async () => {
        const resp = await apolloCall();
        setMessage(CONFIG.SUCCESS_MESSAGE);
        return resp;
    };

    return (
        <MockApolloQueryStyled className="MockApolloQuery">
            <div className="Inner">
                <h1>{title} Mock Query</h1>
                <Button onClick={onClick}>{CONFIG.BUTTON_TEXT}</Button>
                <div className="message">{message}</div>
                {children && <div className="children">{children}</div>}
            </div>
        </MockApolloQueryStyled>
    );
};

export default MockApolloQuery;

// prop-types
MockApolloQuery.propTypes = {
    title: PropTypes.string.isRequired,
    apolloCall: PropTypes.func.isRequired,
    children: PropTypes.any
};
